import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

// Every authenticated user has exactly one memberships/{uid} doc — see
// firestore.rules header comment. This is the single place the app reads
// "who is this person / what can they see" from; nothing else should
// re-derive role from anywhere but this document.
export function watchMembership(uid, cb) {
  return onSnapshot(doc(db, "memberships", uid), (snap) => {
    cb(snap.exists() ? { id: snap.id, ...snap.data() } : null);
  });
}
